// extracted by mini-css-extract-plugin
export default {"root":"_311Ow","avatar":"_18Lp3"};